export default __webpack_public_path__ + "static/media/hannin.981bbd67.jpg";